import { Modal } from "antd";
import { Flex } from "@chakra-ui/react";
import OutlineButton from "components/Button/OutlineButton";
import PrimaryButton from "components/Button/PrimaryButton";
import SelectEquipamento from "components/Input/SelectEquipamento";
import { useState } from "react";

interface ModalSelectEquipamentoProps {
  visible: boolean;
  onClose: () => any;
  onSubmit: (equipamentoId: string) => any;
}

export default function ModalSelectEquipamento({
  onClose,
  visible,
  onSubmit,
}: ModalSelectEquipamentoProps) {
  const [selectedEquipamento, setSelectedEquipamento] = useState<
    string | undefined
  >(undefined);
  return (
    <Modal
      destroyOnClose
      width={"500px"}
      onCancel={onClose}
      centered
      title="Patrimônios"
      visible={visible}
      footer={
        <Flex justifyContent="end" gap={4}>
          <OutlineButton onClick={onClose}> Fechar</OutlineButton>
          <PrimaryButton
            onClick={() => selectedEquipamento && onSubmit(selectedEquipamento)}
          >
            Salvar
          </PrimaryButton>
        </Flex>
      }
    >
      <SelectEquipamento onChange={(e) => setSelectedEquipamento(e)} />
    </Modal>
  );
}
